import React, { useState } from 'react';
import './FlipCard.css';

export default function FlipCard({ card }) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className={`flip-card${flipped ? ' flipped' : ''}`}
      onMouseEnter={() => setFlipped(true)}
      onMouseLeave={() => setFlipped(false)}
      style={{ display: 'inline-block', margin: 16 }}
    >
      <div className="flip-card-inner">
        <div className="flip-card-front">
          {/* Front of card */}
          <div className="card-bg visa">
            <img src="/visa.png" alt="Visa" className="visa-logo" />
            <div className="card-number">{card.card_number || '**** **** **** ****'}</div>
            <div className="card-details">
              <div>
                <div className="label">CARD HOLDER</div>
                <div className="value">{card.full_name || 'CARD HOLDER'}</div>
              </div>
              <div>
                <div className="label">EXPIRES</div>
                <div className="value">{card.expiry || 'MM/YY'}</div>
              </div>
            </div>
            <img src="/quickremit.png" alt="Quick Remit" className="quickremit-logo" />
          </div>
        </div>
        <div className="flip-card-back">
          {/* Back of card */}
          <div className="card-bg visa">
            <div className="magstripe" />
            <div className="cvc-container">
              <div className="cvc-label">CVC</div>
              <div className="cvc-value">{card.cvc || '***'}</div>
            </div>
            <img src="/visa.png" alt="Visa" className="visa-logo back" />
            <img src="/quickremit.png" alt="Quick Remit" className="quickremit-logo back" />
          </div>
        </div>
      </div>
    </div>
  );
}
